export enum SocketStatus {
  Open = 'OPEN',
  Connecting = 'CONNECTING',
  Closed = 'CLOSED'
}
